import { BadgeColors, BadgeColorsProps } from '../components/Badge'

enum MerchandiseOrigin {
  airBnb = 'AIR_BNB',
  stripe = 'STRIPE',
  wholesale = 'WHOLESALE',
  credits = 'CREDITS',
}

export const TRANSACTION_ORIGIN_LABEL: Record<MerchandiseOrigin, string> = {
  [MerchandiseOrigin.airBnb]: 'Airbnb',
  [MerchandiseOrigin.stripe]: 'Stripe',
  [MerchandiseOrigin.wholesale]: 'Wholesale',
  [MerchandiseOrigin.credits]: 'Credits',
}

export const TRANSACTION_ORIGIN_BADGE_COLOR: Record<MerchandiseOrigin, BadgeColorsProps> = {
  [MerchandiseOrigin.airBnb]: BadgeColors.channelAirbnb,
  [MerchandiseOrigin.stripe]: BadgeColors.channelStripe,
  [MerchandiseOrigin.wholesale]: BadgeColors.neutral,
  [MerchandiseOrigin.credits]: BadgeColors.neutral,
}
